/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// ================================
  // MOBILE MENU - DROPDOWNS INLINE
  // (CSS relacionado: theme.css → "MOBILE MENU - DROPDOWNS INLINE")
  // ================================
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-sliderule-open]');
    if (!btn) return;

    const mainMenu = btn.closest('.drawer__main-menu');
    if (!mainMenu) return;

    e.stopImmediatePropagation();
    e.preventDefault();

    const sliderule = btn.closest('mobile-sliderule');
    if (!sliderule) return;

    const panel = sliderule.querySelector('.mobile__menu__dropdown');
    if (!panel) return;

    const isOpen = sliderule.classList.contains('is-open');

    const allSliderules = mainMenu.querySelectorAll('mobile-sliderule.is-open');
    allSliderules.forEach(function(el) {
      if (el !== sliderule) {
        el.classList.remove('is-open');
        const p = el.querySelector('.mobile__menu__dropdown');
        if (p) p.classList.remove('is-visible');
      }
    });

    if (isOpen) {
      sliderule.classList.remove('is-open');
      panel.classList.remove('is-visible');
    } else {
      sliderule.classList.add('is-open');
      panel.classList.add('is-visible');
    }
  }, true);
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
